if (!customElements.get("variant-picker")) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
    }

    get selectedOptionValues() {
      const options = this.querySelectorAll(
        "select, .variant-picker__field input[type='radio']"
      );
      const selectedValues = new Map();

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (field.tagName.toLowerCase() === "select") {
          const selectedOption = Array.from(field.options).find(
            (opt) => opt.selected && !opt.disabled
          );
          if (selectedOption) {
            selectedValues.set(fieldName, selectedOption.dataset.optionValueId);
          }
        } else if (field.type === "radio" && field.checked) {
          selectedValues.set(fieldName, field.dataset.optionValueId);
        }
      });

      const result = [];
      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;
        if (selectedValues.has(fieldName)) {
          const optionValueId = selectedValues.get(fieldName);
          if (optionValueId && !result.includes(optionValueId)) {
            result.push(optionValueId);
          }
        }
      });

      return result;
    }

    get selectedOptionNames() {
      const selectedOptions = [];

      this.querySelectorAll("select").forEach((select) => {
        if (select.value) selectedOptions.push(select.value);
      });

      this.querySelectorAll(".variant-picker__field").forEach((field) => {
        const checked = field.querySelector("input[type='radio']:checked");
        if (checked && checked.value) selectedOptions.push(checked.value);
      });

      return selectedOptions;
    }

    getInputForEventTarget(target) {
      return target.tagName === "SELECT" ? target.selectedOptions[0] : target;
    }

    connectedCallback() {
      this.addEventListener("change", (event) => {
        const target = this.getInputForEventTarget(event.target);

        window.FoxThemeEvents.emit(PUB_SUB_EVENTS.optionValueSelectionChange, {
          data: {
            event,
            target,
            selectedOptionValues: this.selectedOptionValues,
          },
        });

        document.dispatchEvent(
          new CustomEvent("chaarmant:variant-change", {
            detail: {
              sectionId: this.dataset.section,
              selectedOptions: this.selectedOptionNames,
            },
          })
        );
      });
    }
  }

  customElements.define("variant-picker", VariantPicker);
}